"use strict";
exports.__esModule = true;
exports.setPermissions = exports.setAuthorizationConfig = exports.setNamespace = exports.setDisplayName = exports.setDisplayField = void 0;
var validators_1 = require("../validation/validators");
var permissions_1 = require("../permissions");
var types_1 = require("../types");
var setDisplayField = function (value) {
    validators_1.validateDisplayField(value);
    return {
        op: types_1.PatchType.ADD,
        path: "/displayField",
        value: value
    };
};
exports.setDisplayField = setDisplayField;
var setDisplayName = function (value) {
    validators_1.validateDisplayName(value);
    return {
        op: types_1.PatchType.ADD,
        path: "/displayName",
        value: value
    };
};
exports.setDisplayName = setDisplayName;
var setNamespace = function (value) {
    validators_1.validateNamespace(value);
    return {
        op: types_1.PatchType.ADD,
        path: "/namespace",
        value: value
    };
};
exports.setNamespace = setNamespace;
var setAuthorizationConfig = function (value) {
    validators_1.validateAuthorizationConfig(value);
    return {
        op: types_1.PatchType.ADD,
        path: '/permissions',
        value: value
    };
};
exports.setAuthorizationConfig = setAuthorizationConfig;
var setPermissions = function (value) {
    validators_1.validatePermissions(value);
    return {
        op: types_1.PatchType.ADD,
        path: '/permissions',
        value: permissions_1.transformRolesToAuthorizationConfig(value)
    };
};
exports.setPermissions = setPermissions;
//# sourceMappingURL=schemaProperties.js.map